import createVueApp from '@/common/createApp'

Styxie.Initializers.Dashboard = {
  welcome: async(props) => {
    const { default: Welcome } = await import('@/vue_widgets/dashboard/welcome/index.vue')
    createVueApp(Welcome, { props, layout: null })
  }
}
